module.exports = __webpack_public_path__ + "img/pimms.99145892.jpg";